exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stepper-text[data-v-142ad590]{ont-feature-settings:\"clig\" off,\"liga\" off;font-size:15px;line-height:21px}.stepper-text[data-v-142ad590]:not(:first-child){margin-left:-8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-142ad590","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/onboarding/components/stepper.vue
// module id = uIkc
// module chunks = 0